const BASE_DATE = new Date(1997, 9, 7);
const BANK_MAP = {
  '001': 'Banco do Brasil',
  '033': 'Santander',
  '104': 'Caixa Econômica Federal',
  '237': 'Bradesco',
  '341': 'Itaú Unibanco',
  '748': 'Banco Cooperativo Sicredi',
  '756': 'Sicoob',
  '085': 'Cooperativa Central Ailos',
  '260': 'NuBank',
  '290': 'PagBank',
};

const SEGMENTS = {
  '1': 'Prefeituras',
  '2': 'Saneamento',
  '3': 'Energia elétrica e gás',
  '4': 'Telecomunicações',
  '5': 'Órgãos governamentais',
  '6': 'Carnês e assemelhados',
  '7': 'Multas de trânsito',
  '9': 'Outros serviços',
};

export const onlyDigits = str => (str || '').replace(/\D/g, '');

function utilityCheckDigit(digits, reference) {
  let sum = 0;
  let weight = 2;
  for (let i = digits.length - 1; i >= 0; i--) {
    const product = Number(digits[i]) * weight;
    sum += reference === 'mod10' ? Math.floor(product / 10) + product % 10 : product;
    weight = reference === 'mod10' ? (weight === 2 ? 1 : 2) : (weight === 9 ? 2 : weight + 1);
  }
  if (reference === 'mod10') return (10 - sum % 10) % 10;
  const remainder = sum % 11;
  return remainder === 0 || remainder === 1 ? 0 : 11 - remainder;
}

function utilityReference(digits) {
  const reference = digits[2];
  if (reference === '6' || reference === '7') return 'mod10';
  if (reference === '8' || reference === '9') return 'mod11';
  throw new Error('Identificador de valor da conta de consumo inválido.');
}

export function lineToBar(line) {
  const dig = onlyDigits(line);
  if (dig.length === 48 && dig[0] === '8') {
    const reference = utilityReference(dig);
    const blocks = dig.match(/.{12}/g);
    blocks.forEach(block => {
      if (utilityCheckDigit(block.slice(0, 11), reference) !== Number(block[11])) {
        throw new Error('Dígito verificador da conta de consumo inválido.');
      }
    });
    return blocks.map(block => block.slice(0, 11)).join('');
  }
  if (dig.length === 47) {
    return (
      dig.substr(0, 4) +
      dig.substr(32, 1) +
      dig.substr(33, 14) +
      dig.substr(4, 5) +
      dig.substr(10, 10) +
      dig.substr(21, 10)
    );
  }
  if (dig.length === 44) return dig;
  throw new Error('Código deve ter 44, 47 ou 48 dígitos.');
}

export function parseBar(barStr) {
  const bar = onlyDigits(barStr);
  if (bar.length !== 44) throw new Error('Código de barras inválido.');

  if (bar[0] === '8') {
    utilityReference(bar);
    const segment = SEGMENTS[bar[1]] || 'Outros serviços';
    return {
      bancoNome: segment,
      tipo: 'Conta de consumo',
      valor: Number(bar.slice(4, 15)) / 100,
      vencimento: null,
      bar,
    };
  }

  const banco = bar.substr(0, 3);
  const fator = parseInt(bar.substr(5, 4), 10);
  let vencimento = null;
  if (fator !== 0 && fator <= 9999) {
    const dt = new Date(BASE_DATE);
    dt.setDate(dt.getDate() + fator);
    vencimento = dt.toISOString().slice(0, 10);
  }

  return {
    banco,
    bancoNome: BANK_MAP[banco] || `Banco ${banco}`,
    tipo: 'Boleto',
    moeda: bar[3],
    dvGeral: bar[4],
    fator,
    vencimento,
    valor: parseInt(bar.substr(9, 10), 10) / 100,
    campoLivre: bar.substr(19, 25),
    bar,
  };
}
